import { productStatus } from '../apis/constants';

const canApproveProduct = status => [productStatus.designReady, productStatus.productionReady].includes(status);

const approveProductText = status => {
  switch (status) {
    case productStatus.designReady:
      return 'Approve Design';
    case productStatus.changesRequested:
      return 'Changes Requested';
    case productStatus.productionRequest:
      return 'Finalizing Proof';
    case productStatus.productionReady:
      return 'Approve Proof';
    case productStatus.approved:
      return 'Approved';
    case productStatus.inactive:
      return 'Inactive';
    default:
      return 'In Design';
  }
};

const canRequestProductChanges = status => ![productStatus.approved, productStatus.inactive].includes(status);

export { canApproveProduct, approveProductText, canRequestProductChanges };
